// test2269
(2269 && 0);
